import { CLICK_ACTIONS, IMPRESSION_ACTIONS, SCREEN_NAME } from "@payment-client/analytics/constants";
import { AnalyticsContextValue } from "@swiggy-private/checkout-core";

const groupName = "split_payments";

export const splitpayGroupImpressionEvent = (impressionEvent: AnalyticsContextValue["impressionEvent"]): void => {
    impressionEvent({
        category: SCREEN_NAME.PAYMENT,
        action: IMPRESSION_ACTIONS.IMPRESSION_PAYMENT_GROUPS,
        label: JSON.stringify({ groupName }),
    });
};

export const splitpayClickEvent = (context: string, clickEvent: AnalyticsContextValue["clickEvent"]): void => {
    clickEvent({
        category: SCREEN_NAME.PAYMENT,
        action: CLICK_ACTIONS.CLICK_PAYMENT_GROUPS,
        label: JSON.stringify({ groupName }),
        context,
    });
};

export const viewAllRewardsCtaImpressionEvent = (impressionEvent: AnalyticsContextValue["impressionEvent"]): void => {
    impressionEvent({
        category: SCREEN_NAME.PAYMENT,
        action: IMPRESSION_ACTIONS.IMPRESSION_VIEW_ALL_REWARDS,
        label: JSON.stringify({ groupName }),
    });
};

export const viewAllRewardsCtaClickEvent = (clickEvent: AnalyticsContextValue["clickEvent"]): void => {
    clickEvent({
        category: SCREEN_NAME.PAYMENT,
        action: CLICK_ACTIONS.CLICK_VIEW_ALL_REWARDS,
        label: JSON.stringify({ groupName }),
    });
};

export const rewardsHalfCardImpressionEvent = (impressionEvent: AnalyticsContextValue["impressionEvent"]): void => {
    impressionEvent({
        category: SCREEN_NAME.PAYMENT,
        action: IMPRESSION_ACTIONS.IMPRESSION_REWARDS_GROUPS,
    });
};

export const rewardsInHalfcardClickEvent = (
    rewardName: string,
    selected: boolean,
    clickEvent: AnalyticsContextValue["clickEvent"],
): void => {
    clickEvent({
        category: SCREEN_NAME.PAYMENT,
        action: CLICK_ACTIONS.CLICK_REWARDS_GROUPS,
        label: JSON.stringify({
            // eslint-disable-next-line @typescript-eslint/naming-convention
            reward_name: rewardName,
            selected,
        }),
    });
};

export const rewardSuccessfullyAppliedToastImpressionEvent = (
    text: string,
    impressionEvent: AnalyticsContextValue["impressionEvent"],
): void => {
    impressionEvent({
        category: SCREEN_NAME.PAYMENT,
        action: IMPRESSION_ACTIONS.IMPRESSION_REWARD_SUCCESSFULLY_APPLIED_TOAST,
        label: text,
    });
};

export const selectOneSplitpayToastImpressionEvent = (
    text: string,
    impressionEvent: AnalyticsContextValue["impressionEvent"],
): void => {
    impressionEvent({
        category: SCREEN_NAME.PAYMENT,
        action: IMPRESSION_ACTIONS.IMPRESSION_SELECT_ONLY_ONE_SPLITPAY_TOAST,
        label: text,
    });
};

export const crossClickEvent = (clickEvent: AnalyticsContextValue["clickEvent"]): void => {
    clickEvent({
        category: SCREEN_NAME.PAYMENT,
        action: CLICK_ACTIONS.CLICK_CROSS_REWARD_GROUPS,
    });
};
